import React from 'react'
import PropTypes from 'prop-types'

import MessageImage from './MessageImage'
import FilePreview from './FilePreview'

import WithSimpleLightbox from '../../WithSimpleLightbox'

function MessageImages({ attachments, onImageClick, imageAltText }) {
  return (
    attachments.map((image, index) => (
      <div className="attachment__column col-xs-12 col-sm-6 col-md-4 col-lg-3" key={`image-attachment-wrap-${index}`}>
        <div className="attachment__wrapper">
          <FilePreview
            fileName={image.attributes.fileName}
            iconName="image"
            imgUrl={image.attributes.thumbUrl || image.attributes.url}
            imageAltText={index === 0 ? imageAltText : null}
            onImageClick={onImageClick}
            index={index}
          />
          <MessageImage image={image} onImageClick={onImageClick} index={index} download />
        </div>
      </div>
    ))
  )
}

MessageImages.propTypes = {
  attachments: PropTypes.array.isRequired,
  onImageClick: PropTypes.func.isRequired,
  imageAltText: PropTypes.string,
}

export default WithSimpleLightbox(MessageImages)
